import { ReactCaseFlowCase } from '../react-case-flow-case';

export async function CaseFlow_Utils_AlterCaseFacts(
  caseFlowCase: ReactCaseFlowCase,
  facts: { [key: string]: any }
) {
  await caseFlowCase?.Alter_Facts(facts);
  await caseFlowCase?.Commit();
}
